module.exports = "<import-accounting-work-action-list-item ng-if=!clerkLedgerDeliverable.importedLedgerId contents=$ctrl.contents></import-accounting-work-action-list-item> <inspect-imported-ledger-contents-action-list-item ng-if=clerkLedgerDeliverable.importedLedgerId contents=\"{ordinal: $ctrl.contents.ordinal, renderAsMenuItem: $ctrl.contents.renderAsMenuItem, includeActionsInMenu: true}\"></inspect-imported-ledger-contents-action-list-item> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/inspect-or-import-accounting-work.html
// module id = 1731
// module chunks = 86